<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="headline_under">
          <div class="v-super">Logo</div>
        </div>
        <vue-dropzone
          ref="logo_dropzone"
          :options="logo_dropzone_options"
          id="logo_dropzone"
          v-on:vdropzone-file-added="uploading = true"
          v-on:vdropzone-success="processAsset"
          style="margin-bottom:20px;"
        ></vue-dropzone>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="headline_under flex-row-sb">
          <div>
            <div class="v-super">Projektdaten</div>
          </div>
          <feather type="trash" class="infra-blue pointer" @click="openDeleteBpModal" id="deleteBpButton"></feather>
          <b-tooltip target="deleteBpButton" triggers="hover" placement="left">Bauprojekt löschen.</b-tooltip>
        </div>
        <div class="bp-data-form-container">
          <div class="form-group">
            <div class="form-label">Name</div>
            <input class="form-control" type="text" name="name" @blur="processField" v-model="bauprojekt_data.name" />
            <feather type="check" v-if="!name_updating" class="checkmark"></feather>
            <Loader size="20" v-if="name_updating" />
          </div>
          <div class="form-group">
            <div class="form-label">Ort</div>
            <input class="form-control" type="text" name="ort" @blur="processField" v-model="bauprojekt_data.ort" />
            <feather type="check" v-if="!ort_updating" class="checkmark"></feather>
            <Loader size="20" v-if="ort_updating" />
          </div>
          <div class="form-group">
            <div class="form-label">Strasse</div>
            <input class="form-control" type="text" name="strasse" @blur="processField" v-model="bauprojekt_data.strasse" />
            <feather type="check" v-if="!strasse_updating" class="checkmark"></feather>
            <Loader size="20" v-if="strasse_updating" />
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="headline_under flex-row-sb">
          <div class="v-super">Downloads</div>
          <div><feather type="plus" @click="openDownloadModal" class="infra-blue pointer"></feather></div>
        </div>
        <div id="downloads-result-container">
          <div v-for="download in downloads" :key="'bpdownload-' + download.bp_downloads_id" class="download-result">
            <div class="download-label infra-blue">{{ download.name }}</div>
            <div class="download-result-icons">
              <a :href="download.file.data.full_url" target="_blank"><feather type="download" class="infra-blue pointer"></feather></a>
              <feather type="trash" class="infra-blue pointer" @click="deleteDownload(download.relation_id, download.bp_downloads_id)"></feather>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="deleteBpModal" size="md" ok-only>
      <div class="flex-row-sb" style="margin-bottom:20px;">
        <h5>Möchten Sie dieses Bauprojekt wirklich löschen ?</h5>
      </div>
      <div>
        <b-button class="btn-danger" style="width:100%;" @click="deleteBauprojekt">Löschen</b-button>
      </div>
      <template slot="modal-header"
        ><h4>{{ bauprojekt_data.name }} löschen ?</h4></template
      >
      <template slot="modal-ok">Schließen</template>
    </b-modal>
    <b-modal id="bpDownloadModal" @ok.prevent="validateDownload()" @cancel="resetDownloadInputs()">
      <vue-dropzone
        ref="download_dropzone"
        :options="download_dropzone_options"
        id="download_dropzone"
        v-on:vdropzone-file-added="newDownload.file = true"
        v-on:vdropzone-file-removed="newDownload.file = false"
        v-on:vdropzone-success="processDownload"
        v-bind:class="{ file_error: hasError('newBpDownloadFile') }"
        style="margin-bottom:20px;"
      ></vue-dropzone>
      <b-input-group class="form-input-group" prepend="Abc">
        <b-form-input
          class="form-control"
          name="newBpDownloadName"
          v-model="newDownload.name"
          v-bind:class="{ form_error: hasError('newBpDownloadName') }"
        ></b-form-input>
        <feather type="check" v-if="!hasError('newBpDownloadName')" class="checkmark"></feather>
        <feather type="x" v-if="hasError('newBpDownloadName')" class="failmark"></feather>
      </b-input-group>
      <template slot="modal-ok">
        <div>Speichern</div>
      </template>
      <template slot="modal-cancel">
        <div>Abbrechen</div>
      </template>
      <template slot="modal-header">
        <h4>Neuen Download hinzufügen</h4>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import vue2Dropzone from "vue2-dropzone";
import Loader from "@/components/loader.vue";

export default {
  name: "AdminProjektInfos",
  components: {
    vueDropzone: vue2Dropzone,
    Loader: Loader,
  },
  props: ["bauprojekt_id"],
  data() {
    return {
      changes: {},
      uploading: false,
      logo: false,
      badmappe: false,
      gesamtlageplan: false,
      baubeschreibung: false,
      bauprojekt_data: false,
      original_name: false,
      original_ort: false,
      original_strasse: false,
      name_updating: false,
      ort_updating: false,
      strasse_updating: false,
      ready: false,
      deletingBp: false,
      validation_errors: [],
      newDownload: {
        name: "",
        file: false,
      },
      updating: {
        downloads: false,
      },
      downloads: [],
    };
  },
  created: async function() {
    //set local state
    this.setBpData();

    //set original values
    this.original_name = this.bauprojekt_data.name;
    this.original_ort = this.bauprojekt_data.ort;
    this.original_strasse = this.bauprojekt_data.strasse;

    //logo dropzone
    this.logo_dropzone_options = {
      url: this.api.customUploads,
      thumbnailMethod: "contain",
      thumnailWidth: 250,
      maxFiles: 1,
      init: function() {
        this.on("maxfilesexceeded", function(file) {
          this.removeAllFiles();
          this.addFile(file);
        });
      },
      dictDefaultMessage:
        '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload-cloud"><polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline></svg><br/>Logo hierher ziehen oder klicken',

      headers: {
        Authorization: "bearer " + JSON.parse(localStorage.getItem("directus-sdk-js")).token,
        "Cache-Control": null,
        "X-Requested-With": null,
      },
    };

    //baubeschreibung dropzone
    this.download_dropzone_options = {
      url: this.api.customUploads,
      thumbnailMethod: "contain",
      maxFiles: 1,
      autoProcessQueue: false,
      init: function() {
        this.on("maxfilesexceeded", function(file) {
          this.removeAllFiles();
          this.addFile(file);
        });
      },
      dictDefaultMessage:
        '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload-cloud"><polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline></svg>',

      headers: {
        Authorization: "bearer " + JSON.parse(localStorage.getItem("directus-sdk-js")).token,
        "Cache-Control": null,
        "X-Requested-With": null,
      },
    };

    //check if logo exists and set it as preview
    if (this.bauprojekt_data.logo) {
      this.logo = {
        id: this.bauprojekt_data.logo,
        obj: this.bauprojekt_data.extended.logo,
      };
      let image_logo = await this.getImageBlob(this.logo.obj.thumbnails[3].url);
      let file = { size: image_logo.size, name: "Logo", type: image_logo.type };
      this.$refs.logo_dropzone.manuallyAddFile(file, this.logo.obj.full_url);
    }

    //get downloads
    await this.getBpDownloads();

    this.ready = true;
  },
  computed: {
    ...mapGetters({
      bauprojekte: "app/bauprojekte",
      api: "auth/apiSettings",
      toast: "app/toasts",
    }),
  },
  methods: {
    async deleteDownload(relationId, bpDownloadId) {
      try {
        await this.$directus.deleteItem("bauprojekt_bp_downloads", relationId);
        await this.$directus.deleteItem("bp_downloads", bpDownloadId);
      } catch (error) {
        console.log(error);
        console.log("Fehler beim Löschen des Downloads");
      } finally {
        await this.getBpDownloads();
      }
    },
    async getBpDownloads() {
      this.downloads = [];
      try {
        const bpDownloads = await this.$directus.getItems("bauprojekt_bp_downloads", {
          filter: {
            bauprojekt_id: this.$route.params.bauprojekt_id,
          },
          fields: "*.*",
        });
        bpDownloads.data.forEach(async (dl) => {
          const fileId = dl.bp_downloads_id.file;
          const result = await this.$directus.getItem("directus_files", fileId);
          if (result)
            this.downloads.push({
              name: dl.bp_downloads_id.name,
              file: result.data,
              bp_downloads_id: dl.bp_downloads_id.id,
              relation_id: dl.id,
            });
        });
      } catch (error) {
        console.log(error);
        console.log("Fehler beim Hinzufügen eines Downloads.");
      }
    },
    async uploadFile() {
      this.$refs.download_dropzone.processQueue();
    },
    async processDownload(upload, response) {
      const payloadDownload = {
        name: this.newDownload.name,
        file: response.data.id,
        status: "published",
      };

      try {
        const responseDownload = await this.$directus.createItem("bp_downloads", payloadDownload);
        const payloadRelation = {
          bauprojekt_id: this.$route.params.bauprojekt_id,
          bp_downloads_id: responseDownload.data.id,
        };
        await this.$directus.createItem("bauprojekt_bp_downloads", payloadRelation);
      } catch (error) {
        console.log(error);
        console.log("Fehler beim Erzeugen in bp_downloads collection");
      } finally {
        this.hideDownloadModal();
        await this.getBpDownloads();
        this.resetDownloadInputs();
      }
    },
    resetDownloadInputs() {
      this.newDownload = {
        name: "",
        file: false,
      };
      this.validation_errors = [];
      this.newDownload.file = false;
    },
    async validateDownload() {
      this.validation_errors = [];
      const validateImage = this.newDownload.file != false;

      const validateText = await this.$store.dispatch("app/validateField", {
        context: "bpDownload",
        field: "name",
        value: this.newDownload.name,
      });

      if (!validateText) {
        this.validation_errors.push("newBpDownloadName");
        return;
      }

      if (!validateImage) {
        this.validation_errors.push("newBpDownloadFile");
        return;
      }

      await this.uploadFile();
    },
    hasError(field) {
      return this.validation_errors.indexOf(field) > -1 ? true : false;
    },
    openDownloadModal() {
      this.$bvModal.show("bpDownloadModal");
    },
    hideDownloadModal() {
      this.$bvModal.hide("bpDownloadModal");
    },
    async processField(field) {
      const changedField = field.target.name;
      const changed = this["original_" + changedField] !== this.bauprojekt_data[changedField];
      if (!changed) return;
      let changedData = {};
      changedData[changedField] = this.bauprojekt_data[changedField];
      this[changedField + "_updating"] = true;
      try {
        await this.$directus.updateItem("bauprojekt", this.bauprojekt_data.id, changedData);

        await this.$store.dispatch("app/updateSingle", {
          resource: "bauprojekt",
          id: this.bauprojekt_data.id,
        });

        this[changedField + "_updating"] = false;
      } catch (error) {
        console.log(error);
      }
    },
    async processAsset(response = null, data = null) {
      //handle error / success of upload
      if (!response.xhr.status == 200) {
        this.$toasted.show("Fehler beim Upload", this.toast.error);
        return;
      }
      this.$toasted.show(data.data.filename_download + " Datum.", this.toast.success);

      //determine which asset was uploaded and write it to the changes object
      const asset_type = response.previewElement.parentNode.id.split("_")[0];

      //tag the item in directus with the correct asset type
      try {
        this.$directus.updateItem("directus_files", data.data.id, {
          tags: [asset_type, "draft"],
        });
      } catch (error) {
        console.log(error);
      }

      let updatePayload = null;

      //set payload type
      switch (asset_type) {
        case "badmappe":
          updatePayload = {
            badmappe: data.data.id,
          };
          break;
        case "baubeschreibung":
          updatePayload = {
            baubeschreibung: data.data.id,
          };
          break;
        case "gesamtlageplan":
          updatePayload = {
            gesamtlageplan: data.data.id,
          };
          break;
        case "logo":
          updatePayload = {
            logo: data.data.id,
          };
          break;
      }

      //deliver payload to directus
      try {
        this.$directus.updateItem("bauprojekt", this.$route.params.bauprojekt_id, updatePayload);
      } catch (error) {
        console.log(error);
      }

      //set the chosen asset
      this[asset_type] = {
        id: data.data.id,
        obj: data.data.data,
        filename: data.data.filename_download,
      };

      try {
        await this.$store.dispatch("app/updateSingle", {
          resource: "bauprojekt",
          id: this.bauprojekt_id,
        });
        this.setBpData();
      } catch (error) {
        console.log(error);
      }
      //unset uploading state
      this.uploading = false;
    },
    async validate() {
      //check for changes
      console.log("validate called: ");
    },
    async getImageBlob(imageUrl) {
      const response = await fetch(imageUrl);
      return response.blob();
    },
    galleryRemove(file) {
      let json = JSON.parse(file.xhr.response).data;
      const removeMe = this.gallery.find((el) => el.id == json.id);
      this.gallery.splice(removeMe, 1);
    },
    processUploadState() {
      this.uploading = true;
    },
    async removeAsset(asset) {
      let payload = {};
      payload[asset] = null;
      await this.$directus.updateItem("bauprojekt", this.bauprojekt_data.id, payload);
      this[asset] = false;
      await this.$store.dispatch("app/updateSingle", {
        resource: "bauprojekt",
        id: this.bauprojekt_id,
      });
      this.setBpData();
    },
    clip(str) {
      if (str.length > 25) {
        return str.substr(0, 25) + "...";
      }
    },
    setBpData() {
      const bauprojekt = this.bauprojekte.find((bp) => bp.id == this.$route.params.bauprojekt_id);
      this.bauprojekt_data = bauprojekt;
    },
    openDeleteBpModal() {
      console.log("openDeleteBpModal");
      this.$bvModal.show("deleteBpModal");
    },
    async deleteBauprojekt() {
      const deleteBpPayload = {
        collection: "bauprojekt",
        item: this.bauprojekt_data.id,
        changes: {
          status: "draft",
        },
      };

      try {
        this.deletingBp = true;
        await this.$store.dispatch("app/mutate", deleteBpPayload);
        await this.$store.dispatch("app/apiGetBauprojekte");
        this.$router.push({ name: "admin-bauprojekte" });
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim löschen des Bauprojekts", this.toasts.failure);
      } finally {
        this.deletingBp = false;
      }
    },
  },
};
</script>

<style>
.bp-data-form-container {
  margin-top: 20px;
  margin-bottom: 20px;
}

.dropzone .dz-preview {
  height: 100% !important;
  width: 100% !important;
}
.dropzone .dz-preview .dz-image {
  width: 100% !important;
  height: auto !important;
}

#logo_dropzone .dz-preview .dz-image img {
  width: inherit !important;
  height: inherit !important;
}

#logo_dropzone {
  position: relative !important;
}

#logo_dropzone .dz-default.dz-message {
  width: 100% !important;
}

.dz-row {
  display: flex;
  justify-content: space-between;
}

#gesamtlageplan_dropzone,
#badmappe_dropzone,
#baubeschreibung_dropzone {
  min-height: 20px !important;
  line-height: 20px !important;
  width: 30px !important;
  display: inline-block;
  vertical-align: bottom;
  margin-right: 0px;
  border: none !important;
  background: transparent !important;
  text-align: right;
}

#gesamtlageplan_dropzone .dz-default.dz-message,
#badmappe_dropzone .dz-default.dz-message,
#baubeschreibung_dropzone .dz-default.dz-message {
  position: absolute !important;
  height: auto;
  width: 30px !important;
  top: 0px !important;
  left: 0px !important;
  right: 0px !important;
  bottom: 0px !important;
  cursor: pointer !important;
}

#gesamtlageplan_dropzone .dz-preview,
#badmappe_dropzone .dz-preview,
#baubeschreibung_dropzone .dz-preview {
  display: none !important;
}

#gesamtlageplan_dropzone.dropzone.dz-started .dz-message,
#badmappe_dropzone.dropzone.dz-started .dz-message,
#baubeschreibung_dropzone.dropzone.dz-started .dz-message {
  display: inline-block !important;
  opacity: 1 !important;
}

.dropzone svg {
  cursor: pointer !important;
}

.asset-status-message {
  display: inline-block;
}

.small-dropzone-buttons > * {
  margin-left: 5px;
}

.pointer {
  cursor: pointer;
}
</style>

<style scoped>
.form-group {
  position: relative;
}

.checkmark {
  color: green;
}

.loader {
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  -moz-backdrop-filter: none;
}
.loader,
.checkmark {
  position: absolute;
  bottom: 7px;
  right: 10px;
  display: block;
  height: 20px;
  width: 20px;
}

.file_error {
  border: 2px solid red;
}

.download-label {
  font-size: 1.4em;
}

.downloads-result-container,
.download-result {
  display: flex;
  justify-content: space-between;
}

.download-result {
  flex-flow: row;
}
</style>
